export default {
  SET_COLORS(state, data) {
    state.colorOptions = data;
  },
  SET_PORT_OPTIONS(state, data) {
    state.portOptions = data;
  },
  SET_RANK_OPTIONS(state, data) {
    state.rankOptions = data;
  },
  SET_DISPLAY_SETTINGS(state, data) {
    state.displaySettings = data;
  },
  SET_SELECTED_PORT(state, data) {
    state.selectedPort = data;
  },
  SET_STORED_MASTER_SEARCH_CONDITION(state, data) {
    state.storedMasterSearchCondition = data;
  },
}